module.exports = __webpack_public_path__ + "static/media/_img_logo.bed0967c.png";